import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import Image from "../../components/image";

class Item extends Component {
    render() {
        const { item, locale } = this.props;

        return (
            <Link title={item.title} className="flex mb-28 flex-col">
                <h1 className={"font-judge font-bold text-30 mb-30 flex-1"}>
                    {item.title.toUpperCase()}
                </h1>
                <Image
                    alt={item.title}
                    url={item.image}
                    aspectRatio="aspect-ratio-85/96"
                />
                <div className="border-b border-blue mt-25 pb-20 flex-1">
                    <p className={"font-bold text-23"}>{item.author}</p>
                    <p className={"text-23 mt-6"}>
                        {item.year + " - " + item.edition}
                    </p>
                </div>
            </Link>
        );
    }
}

Item.defaultProps = {};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
